import { createSlice } from '@reduxjs/toolkit';

import { getMessageBrokerMultiaddrThunk } from '@/store/thunks/organization/getMessageBrokerMultiaddrThunk';
import { extractThunkError } from '@/store/utils';
import { initialOrganizationSessionState } from '@/types/organization/OrganizationSessionState';

const organizationSlice = createSlice({
  name: 'organization',
  initialState: initialOrganizationSessionState,
  reducers: {
    resetOrganizationState: () => initialOrganizationSessionState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMessageBrokerMultiaddrThunk.pending, (state) => {
        state.loadingMessageBrokerMultiaddr = true;
        state.error = null;
      })
      .addCase(getMessageBrokerMultiaddrThunk.fulfilled, (state, action) => {
        state.loadingMessageBrokerMultiaddr = false;
        state.messageBrokerMultiaddr = action.payload.multiAddr;
        state.error = null;
      })
      .addCase(getMessageBrokerMultiaddrThunk.rejected, (state, action) => {
        const { message } = extractThunkError(action.payload);
        state.loadingMessageBrokerMultiaddr = false;
        state.messageBrokerMultiaddr = null;
        state.error = message ?? action.error.message ?? 'Unknown error';
      });
  },
});

export const { resetOrganizationState } = organizationSlice.actions;
export default organizationSlice.reducer;
